import React, { useState } from "react";
import Modal from "@mui/material/Modal";

const DraggableModal = ({ open, onClose, children }) => {
  const [position, setPosition] = useState({ x: window.innerWidth - 310, y: "12%" });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    setIsDragging(true);
    // Calculate the offset between click position and modal position
    const rect = e.currentTarget.getBoundingClientRect();
    setDragOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      // Update position based on mouse movement and initial offset
      setPosition({
        x: e.clientX - dragOffset.x,
        y: e.clientY - dragOffset.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  React.useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: {
          backgroundColor: "transparent", // Makes backdrop transparent
        },
      }}
      style={{
        border: "none",
        outline: "none",
        background: "transparent",
      }}
      sx={{
        // Using MUI's sx prop for more specific styling
        "& .MuiBackdrop-root": {
          background: "transparent",
        },
      }}
    >
      <div
        style={{
          position: "absolute",
          top: position.y,
          left: position.x,
          width: "290px",
          backgroundColor: "white",
          borderRadius: "8px",
          cursor: isDragging ? "grabbing" : "grab",
        }}
      >
        <div onMouseDown={handleMouseDown}>{children}</div>
      </div>
    </Modal>
  );
};

export default DraggableModal;
